import React from 'react';
import {Button, DatePicker, Form, Input, InputNumber} from 'antd';
import TypeSelector from './TypeSelector';
import useCollectionWorkProject, {ICollectionWorkProject} from '../../hooks/apis/useCollectionWorkProject';
import {CollectionWorkProjectType} from '../../hooks/apis/useCollectionWork';
import moment, {Moment} from 'moment';
import CollectionWorkProjectStatusConfigSelector from './StatusConfigSelector';
import {CollectionWorkProjectStatusConfig} from '../../hooks/apis/useCollectionWorkProjectRecord';
import CommonApiErrorHandler from '../../utils/HttpInstance';

export interface ICollectionWorkProjectEditForm {
  collectionWorkId?: number;
  name: string;
  type: CollectionWorkProjectType;
  fileSizeMb: number;
  beginTime: Moment;
  endTime: Moment;
  statusConfig: CollectionWorkProjectStatusConfig;
  remark: string;
  maxScore: number;
}
const CollectionWorkProjectEditForm = (props: {
  collectionWorkProject?: ICollectionWorkProject;
  collectionWorkId?: number;
  onFinish?: (form: ICollectionWorkProjectEditForm) => any;
}) => {
  const [form] = Form.useForm();
  const submitHook = useCollectionWorkProject.save();

  const defaultForm: ICollectionWorkProjectEditForm = {
    beginTime: moment(),
    endTime: moment().add(1, 'day'),
    fileSizeMb: 200,
    name: '',
    remark: '',
    maxScore: 100,
    statusConfig: CollectionWorkProjectStatusConfig.关闭,
    type: CollectionWorkProjectType.文档,
  };
  React.useEffect(() => {
    if (props.collectionWorkProject) {
      form.setFieldsValue({
        collectionWorkId: props.collectionWorkProject.collectionWorkId,
        name: props.collectionWorkProject.name,
        type: props.collectionWorkProject.type,
        fileSizeMb: props.collectionWorkProject.fileSizeMb,
        remark: props.collectionWorkProject.remark,
        maxScore: props.collectionWorkProject.maxScore,
      });
    } else {
      form.setFieldsValue(defaultForm);
    }
  }, [props.collectionWorkProject]);

  function onFinish(form: ICollectionWorkProjectEditForm) {
    submitHook
      .request({
        collectionWorkId: props.collectionWorkId,
        fileSizeMb: form.fileSizeMb,
        id: props.collectionWorkProject?.id,
        name: form.name,
        remark: form.remark,
        type: form.type,
        maxScore: form.maxScore,
      })
      .then(i => {
        props.onFinish && props.onFinish(form);
      })
      .catch(CommonApiErrorHandler);
  }
  return (
    <Form
      labelCol={{span: 6}}
      wrapperCol={{span: 14}}
      layout={'horizontal'}
      form={form}
      onFinish={value => {
        onFinish(value as ICollectionWorkProjectEditForm);
      }}>
      <Form.Item label={'征集项目名称'} name={'name'} rules={[{required: true}]}>
        <Input size={'large'} placeholder="请输入征集项目名称" />
      </Form.Item>
      <Form.Item label={'类型'} name={'type'} rules={[{required: true}]}>
        <TypeSelector />
      </Form.Item>
      <Form.Item label={'文件大小'} name={'fileSizeMb'} rules={[{required: true}]}>
        <InputNumber min={1} parser={value => (value ? value.replace('Mb', '') : 0)} formatter={value => `${value}Mb`} />
      </Form.Item>
      <Form.Item label={'满分'} name={'maxScore'} rules={[{required: true}]}>
        <InputNumber min={1} formatter={value => `${value}分`} />
      </Form.Item>
      <Form.Item label={'备注'} name={'remark'} rules={[{required: true}]}>
        <Input.TextArea rows={3} placeholder="请输入备注" />
      </Form.Item>
      <Form.Item>
        <Button loading={submitHook.loading} htmlType={'submit'} type={'primary'}>
          提交
        </Button>
      </Form.Item>
    </Form>
  );
};
export default CollectionWorkProjectEditForm;
